import React, {useState, useEffect} from 'react';
import { searchOnEnter, searchOrReset } from '../../components/searchOnEnter';
import  Sidebar from '../../components/Staff/Sidebar';
import TopBar from '../../components/Staff/TopBar';
import MetaData from '../../layouts/MetaData';
import Loader from '../../layouts/Loader';
import { useSelector, useDispatch } from 'react-redux';
import folderImg from '../../assets/Images/folder.png';
import { Link, useHistory } from 'react-router-dom';
import { getDoctorCCMPatients, searchDoctorCCMPatient, patientActivate, patientDeActivate } from '../../actions/adminActions';
import IncludeDeactivatedToggle from '../../components/IncludeDeactivatedToggle';
import { DropdownButton, Dropdown, Badge, Form, InputGroup } from 'react-bootstrap';
import { formatClinicianName } from '../../utils/clinicianName';
import { useSortableTable, SortableTh, personName } from '../../components/SortableTable';
import DeactivatePatientModal from '../../components/DeactivatePatientModal';
import { isDeceasedPatient } from '../../utils/deactivationReasons';
import { formatDob } from '../../utils/dateFormat';

const PATIENT_LIST_SORT_COLUMNS = {
    emrId: { type: 'string', value: (p) => p?.emrId },
    name: { type: 'name', value: personName },
    dob: { type: 'date', value: (p) => p?.DOB },
    status: { type: 'boolean', value: (p) => p?.block },
    provider: { type: 'name', value: (p) => personName(p?.assigned_doctor_id) },
    consent: { type: 'string', value: (p) => p?.patientType },
};


const StaffCCMPatients = () => {
 
    const {CcmPatients} = useSelector(state => state.doctorStats);
    const { user, isAuthenticated} = useSelector(state => state.auth);
    const { loading, doctorpatients } = useSelector(state => state.docPatients);
    const tableSort = useSortableTable(doctorpatients, { id: 'provider.ccmPatients', columns: PATIENT_LIST_SORT_COLUMNS, defaultSort: { key: 'name', dir: 'asc' } });

    const [keyword, setKeyword] = useState('');
    const [searchBy, setSearchBy] = useState('');

    const history = useHistory();
    const dispatch = useDispatch();
    
    let id = user._id;
    const [includeDeactivated, setIncludeDeactivated] = useState(false);

    useEffect(() => {
        dispatch(getDoctorCCMPatients(id, includeDeactivated));
	}, [dispatch, includeDeactivated])

    const [deactivateTarget, setDeactivateTarget] = useState(null);
    // Deactivation goes through DeactivatePatientModal (required reason); its confirm re-enters with the reason.
    const toggleStatus = async (patient, deactivation) => {
        const deactivate = patient?.block !== true;
        if (deactivate && !deactivation) { setDeactivateTarget(patient); return; }
        if (!deactivate && isDeceasedPatient(patient)) { window.alert('This patient is marked deceased. Only a Super Admin can reactivate (Inactive Patients list).'); return; }
        if(deactivation || window.confirm((deactivate ? 'Deactivate ' : 'Reactivate ') + (patient?.lastname||'') + ', ' + (patient?.firstname||'') + '?')){
            await dispatch(deactivate ? patientDeActivate(patient._id, deactivation) : patientActivate(patient._id));
            dispatch(getDoctorCCMPatients(id, includeDeactivated));
        }
    }

    const searchhandler = () => {
        dispatch(searchDoctorCCMPatient(id, searchBy, keyword));
    }

    return (
    <>
    <MetaData title="CCM Patients"/>
                <Sidebar />    

            <section className="home-section">
                {/* TopBar */}
                <TopBar />

                {loading ? <Loader /> : <>
                <div className="shadow-lg p-3 mb-5 mr-4 ml-4 bg-white rounded">        
                    <div className="home-content">
                        <div>
                            <div className="row-display">
                                <h5 className="title">CCM Patients 
                                    <p style={{color: '#004aad'}}>
                                        <small> Total CCM patients are: {CcmPatients && CcmPatients < 10 ? '0'+CcmPatients : CcmPatients} </small> 
                                    </p>
                                </h5>

                                <div>
                                <div className="row">
                                    <div className="row-display">
                                    
                                        <select 
                                            className="form-control select-input-type" 
                                            value={searchBy}
                                            onChange={e => setSearchBy(e.target.value)}
                                            >
                                                <option value="undefined">Filter Patient </option>
                                                <option value="firstname">Firstname</option>
                                                <option value="lastname">Lastname</option>
                                                <option value="email">email</option>
                                                <option value="phone1">phone1</option>
                                                <option value="address">Address</option>
                                                <option value="state">State</option>
                                                <option value="city">City</option>
                                                <option value="zipCode">Zip Code</option>
                                        </select>    
                                            &nbsp;
                                            <IncludeDeactivatedToggle checked={includeDeactivated} onChange={setIncludeDeactivated} />
                                            &nbsp;
                                            <InputGroup>
                                                    <Form.Control
                                                        placeholder="Search here ..."
                                                        aria-label="Search here ..."
                                                        className="form-control"
                                                        style={{width: '200px'}}
                                                        value={keyword}
                                                        onChange={e => setKeyword(e.target.value) }
                                                        onKeyDown={searchOnEnter(searchhandler, () => dispatch(getDoctorCCMPatients(id, includeDeactivated)))}
                                                    />
                                                    &nbsp;<button className="btn btn-outline-primary btn-sm" 
                                                        id="button-addon2" onClick={() => searchOrReset(keyword, searchhandler, () => dispatch(getDoctorCCMPatients(id, includeDeactivated)))}>
                                                        <i className='bx bx-search-alt'></i>
                                                    </button>
                                            </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />


                            {doctorpatients?.length > 0 ? <>
                                <div className="col-md-12">
                                    <>
                                        <table className="table table-sm table-striped">
                                        <thead align="center">
                                        <tr>  
                                            <SortableTh sortKey="name" sort={tableSort}>Name</SortableTh>
                                            <SortableTh sortKey="dob" sort={tableSort}>DOB</SortableTh>
                                            <SortableTh sortKey="status" sort={tableSort}>Acc Status</SortableTh>
                                            <SortableTh sortKey="provider" sort={tableSort}>Physician</SortableTh>
                                            <SortableTh sortKey="consent" sort={tableSort}>Consent Program</SortableTh>
                                            <th>Actions</th> 
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {tableSort.rows.map((patient, index) => ( 
                                            <tr align="center" key={index}>
                                            <td><Link className="link" to={{ pathname: "/doctor/patient/profile", state: {patientid: patient?._id, deviceid: patient?.deviceassigned?.deviceid}}}>{patient?.firstname} {patient?.lastname} <p>{patient?.phone1}</p></Link></td>
                                            
                                            <td> {formatDob(patient?.DOB)} <p><Badge bg="success text-white">{patient?.gender}</Badge></p></td>
                                            
                                            
                                            {patient?.block === false ? <td>
                                                <Badge pill bg="success text-white" style={{fontSize: '12px', fontWeight: 300}}>Active</Badge>
                                                </td> : <td><Badge pill bg="danger text-white" style={{fontSize: '12px'}}>Inactive</Badge>
                                            </td>}

                                            {patient?.assigned_doctor_id ? <>
                                                <td className="text-nowrap" style={{fontWeight: 'bold', color: '#23408e'}}>{formatClinicianName(patient?.assigned_doctor_id)}</td>
                                                </> : <>
                                                <td><Badge pill bg="danger text-white" style={{fontSize: '12px'}}>Not Assigned</Badge></td>
                                            </>}
                                            
                                            <td>{patient?.patientType}</td>

                                            <td>
                                                <DropdownButton id="dropdown-basic-button" variant="Light">
                                                    <Dropdown.Item>
                                                        <Link className="link" to={{ pathname: "/doctor/patientprofile/ccm", state: {patientid: patient?._id}}}>View Profile</Link>
                                                    </Dropdown.Item>
                                                    {patient?.block === true
                                                        ? <Dropdown.Item onClick={() => toggleStatus(patient)}>Reactivate patient</Dropdown.Item>
                                                        : <Dropdown.Item onClick={() => toggleStatus(patient)}>Deactivate patient</Dropdown.Item>}
                                                </DropdownButton>
                                            </td>
                                        </tr> 
                                        
                                        ))}
                                        
                                        </tbody>
                                        </table>    
                                    </>                      
                            </div>
                        </>  : <>

                        <div>   
                            <img src={folderImg} className="no-record-found-img"/>
                            <p className="doctor-specilizations">Not Found Any Patient...</p>         
                        </div>
                        </> }
                        </div>
                    </div>
                </div>
                </>
            }

                <DeactivatePatientModal
                show={!!deactivateTarget}
                patient={deactivateTarget}
                onCancel={() => setDeactivateTarget(null)}
                onConfirm={(deactivation) => { const p = deactivateTarget; setDeactivateTarget(null); toggleStatus(p, deactivation); }}
            />
            </section>
    </>
  )
}

export default StaffCCMPatients